<template>
  <Tooltip>
    <template #element>
      <span>
        Anmerkung (optional) 
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Beschreibe deine Erwartungen an die Anwendung der Methode oder mit welchen Voraussetzungen du in die Umsetzung startest
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
